import React from 'react';
import { ReviewStatus, getStatusDisplayText } from '../types';
import { CheckCircle2, AlertTriangle, XCircle, MinusCircle, ShieldCheck, Clock } from 'lucide-react';

interface StatusBadgeProps {
  status: ReviewStatus | string;
  size?: 'sm' | 'md';
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ status, size = 'md' }) => {
  // Normalize status to ReviewStatus enum
  const normalizedStatus = (typeof status === 'string' ? status.toLowerCase() : status) as ReviewStatus;
  
  const config = {
    [ReviewStatus.COMPLIANT]: {
      bg: 'bg-emerald-50',
      text: 'text-emerald-700',
      border: 'border-emerald-200',
      icon: CheckCircle2,
      label: '合规'
    },
    [ReviewStatus.NON_COMPLIANT]: {
      bg: 'bg-rose-50',
      text: 'text-rose-700',
      border: 'border-rose-200',
      icon: XCircle,
      label: '不合规'
    },
    [ReviewStatus.UNCERTAIN]: {
      bg: 'bg-amber-50',
      text: 'text-amber-700',
      border: 'border-amber-200',
      icon: AlertTriangle,
      label: '不确定'
    },
    [ReviewStatus.IGNORED]: {
      bg: 'bg-slate-100',
      text: 'text-slate-600',
      border: 'border-slate-200',
      icon: MinusCircle,
      label: '已忽略'
    },
    [ReviewStatus.EXEMPTED]: {
      bg: 'bg-blue-50',
      text: 'text-blue-700',
      border: 'border-blue-200',
      icon: ShieldCheck,
      label: '已豁免'
    },
    [ReviewStatus.PENDING]: {
      bg: 'bg-slate-50',
      text: 'text-slate-400',
      border: 'border-slate-100',
      icon: Clock,
      label: '待审核'
    }
  };

  const style = config[normalizedStatus] || config[ReviewStatus.PENDING];
  const Icon = style.icon;
  const sizeClasses = size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm';

  return (
    <div className={`inline-flex items-center gap-1.5 border rounded-full font-medium ${style.bg} ${style.text} ${style.border} ${sizeClasses}`}>
      <Icon size={size === 'sm' ? 12 : 14} />
      <span>{style.label}</span>
    </div>
  );
};

export default StatusBadge;
